import { render, staticRenderFns } from "./inventedDict.vue?vue&type=template&id=a19da1f6&"
import script from "./inventedDict.vue?vue&type=script&lang=js&"
export * from "./inventedDict.vue?vue&type=script&lang=js&"
import style0 from "./inventedDict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a19da1f6')) {
      api.createRecord('a19da1f6', component.options)
    } else {
      api.reload('a19da1f6', component.options)
    }
    module.hot.accept("./inventedDict.vue?vue&type=template&id=a19da1f6&", function () {
      api.rerender('a19da1f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/inventedDict.vue"
export default component.exports